import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Grid, Autoplay, Thumbs, EffectFlip, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-flip';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';

import SwiperAnimation from '@cycjimmy/swiper-animation'

// Initialize Swiper modules
Swiper.use([Navigation, Pagination, Grid, Autoplay, Thumbs, EffectFlip, Keyboard]);
window.Swiper = Swiper;

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";

const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();

    let heroSwiper = new Swiper("#heroSwiper", {
        modules: [Pagination],
        slidesPerView: 1,
        loop: true,
        pagination: {
            clickable: true,
            el: "#heroSwiperPagination",
        },
    });

    let gallerySwiper = new Swiper("#gallerySwiper", {
        modules: [Grid, Navigation],
        slidesPerView: 1.8,
        loop: true,
        spaceBetween: 5,
        centeredSlides:true,
        breakpoints: {
            370: {
                slidesPerView: 2,
                spaceBetween: 0,
            },
            480: {
                slidesPerView: 2.7,
                spaceBetween: 5,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 2.2,
            },
            1280: {
                slidesPerView: 3,
                grid: {
                    rows: 2,
                    fill: 'row'
                },
                loop: false,
                spaceBetween: 14,
                enabled: false,
                centeredSlides: false,
            },
        },
    });

    const servicesSwiperOpt = {
        modules: [Grid, Navigation],
        slidesPerView: 1.5,
        // loop: true,
        spaceBetween: 5,
        breakpoints: {
            370: {
                slidesPerView: 2,
                grid: {
                    rows: 2,
                    fill: 'row'
                },
            },
            480: {
                slidesPerView: 2.5,
                grid: {
                    rows: 2,
                    fill: 'row'
                },
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 3,
                grid: {
                    rows: 2,
                    fill: 'row'
                },
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 3,
                grid: {
                    rows: 2,
                    fill: 'row'
                },
                spaceBetween: 20,
            },
            1280: {
                slidesPerView: 4,
                grid: {
                    rows: 2,
                    fill: 'row'
                },
                spaceBetween: 60,
                enabled: false,
            },
        },

        navigation: {
            nextEl: "#servicesSwiperPrev",
            prevEl: "#servicesSwiperNext",
        },
    };

    let servicesSwiper = new Swiper("#servicesSwiper", servicesSwiperOpt);

    let blogSwiper = new Swiper("#blogSwiper", {
        slidesPerView: 1.2,
        // loop: true,
        spaceBetween:20,
        breakpoints: {
            370: {
                slidesPerView: 1.7,
            },
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2.2,
            },
            1024: {
                slidesPerView: 3,
            },
            1280: {
                slidesPerView: 4.3,
            },
        },
    });

    const breakpoint = window.matchMedia( '(min-width:1024px)' );
    if ( breakpoint.matches === true  ) {
        try {
            if( servicesSwiper.el instanceof HTMLElement) {
                servicesSwiper.destroy()
                document.getElementById("servicesSwiperWrapper").classList.remove("swiper-wrapper");
            }
        } catch(e) {
            console.log(e)
        }
    }
    else if ( breakpoint.matches === false ) {
        if( !servicesSwiper.enabled ) {
            document.getElementById("servicesSwiperWrapper").classList.add("swiper-wrapper");
            servicesSwiper = new Swiper(servicesSwiperOpt)
        }
    }
}

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})
